import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import FileField from '../../../components/FileField'
import FormRow from '../../../components/FormRow'
import { usersPurge } from '../installService'
import { strings as S } from '../strings'

export default function UsersPurgeTab({ onRun }) {
  const [file, setFile] = useState(null)

  return (
    <Card
      footer={
        <Button variant="danger" disabled={!file} onClick={() => onRun(() => usersPurge(file))}>
          {S.usersPurge.action}
        </Button>
      }
    >
      <FormRow label={S.usersPurge.fileLabel}>
        {(id) => <FileField id={id} name="users" accept=".txt" required onChange={setFile} />}
      </FormRow>
    </Card>
  )
}
